import React, { useState } from 'react';
import { useIsMobile } from '../hooks/useIsMobile';

export default function TwoPathsLanding({ onChoose }) {
  const [hovered, setHovered] = useState(null);
  const isMobile = useIsMobile();

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 2000,
      display: 'flex', flexDirection: 'column',
      background: 'var(--bg)',
    }}>
      {/* Grain overlay */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.04,
        backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\'/%3E%3C/svg%3E")',
        pointerEvents: 'none',
      }} />

      {/* Top label */}
      <div style={{
        position: 'absolute', top: '40px', left: '50%', transform: 'translateX(-50%)',
        fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.3em',
        color: 'var(--ink-light)', textTransform: 'uppercase', whiteSpace: 'nowrap',
      }}>
        Mekhal Raj Rajendran
      </div>

      {/* Two halves */}
      <div style={{ display: 'flex', flex: 1, flexDirection: isMobile ? 'column' : 'row' }}>
        {/* LEFT — Explore My Work */}
        <div
          onClick={() => onChoose('work')}
          onMouseEnter={() => !isMobile && setHovered('work')}
          onMouseLeave={() => !isMobile && setHovered(null)}
          style={{
            flex: isMobile ? 1 : (hovered === 'work' ? 1.4 : hovered === 'vision' ? 0.6 : 1),
            display: 'flex', flexDirection: 'column',
            justifyContent: 'center', alignItems: 'flex-start',
            padding: isMobile ? '0 8% 0 8%' : '0 8% 0 12%',
            borderRight: isMobile ? 'none' : '1px solid rgba(26,26,26,0.1)',
            borderBottom: isMobile ? '1px solid rgba(26,26,26,0.1)' : 'none',
            cursor: 'crosshair',
            transition: 'flex 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            background: hovered === 'work' ? 'rgba(26,26,26,0.02)' : 'transparent',
          }}
        >
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.3em', color: 'var(--ink-light)', marginBottom: '24px', textTransform: 'uppercase' }}>
            01 /
          </div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 72px)', fontWeight: 600, color: 'var(--ink)', lineHeight: 0.95, marginBottom: '20px', letterSpacing: '-0.03em' }}>
            Explore<br />My Work
          </div>
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink-mid)', fontWeight: 300, maxWidth: '280px', lineHeight: 1.6, marginBottom: '40px' }}>
            For recruiters, hiring managers & collaborators
          </div>
          <div style={{
            fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.2em',
            color: 'var(--ink)', textTransform: 'uppercase',
            display: 'flex', alignItems: 'center', gap: '10px',
            opacity: hovered === 'work' || isMobile ? 1 : 0.4, transition: 'opacity 0.3s',
          }}>
            <span>Enter</span>
            <span style={{ fontSize: '16px', transform: hovered === 'work' ? 'translateX(4px)' : 'none', transition: 'transform 0.3s' }}>→</span>
          </div>
        </div>

        {/* RIGHT — Explore My Vision */}
        <div
          onClick={() => onChoose('vision')}
          onMouseEnter={() => !isMobile && setHovered('vision')}
          onMouseLeave={() => !isMobile && setHovered(null)}
          style={{
            flex: isMobile ? 1 : (hovered === 'vision' ? 1.4 : hovered === 'work' ? 0.6 : 1),
            display: 'flex', flexDirection: 'column',
            justifyContent: 'center', alignItems: 'flex-start',
            padding: '0 8% 0 8%',
            cursor: 'crosshair',
            transition: 'flex 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            background: hovered === 'vision' ? 'rgba(232,197,71,0.04)' : 'transparent',
          }}
        >
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.3em', color: 'var(--ink-light)', marginBottom: '24px', textTransform: 'uppercase' }}>
            02 /
          </div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 72px)', fontWeight: 600, color: 'var(--ink)', lineHeight: 0.95, marginBottom: '20px', letterSpacing: '-0.03em' }}>
            Explore<br />My Vision
          </div>
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink-mid)', fontWeight: 300, maxWidth: '280px', lineHeight: 1.6, marginBottom: '40px' }}>
            For investors, founders & builders
          </div>
          <div style={{
            fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.2em',
            color: 'var(--ink)', textTransform: 'uppercase',
            display: 'flex', alignItems: 'center', gap: '10px',
            opacity: hovered === 'vision' || isMobile ? 1 : 0.4, transition: 'opacity 0.3s',
          }}>
            <span>Enter</span>
            <span style={{ fontSize: '16px', transform: hovered === 'vision' ? 'translateX(4px)' : 'none', transition: 'transform 0.3s' }}>→</span>
          </div>
        </div>
      </div>

      {/* Center divider line — desktop only */}
      {!isMobile && (
        <div style={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          width: '1px', height: '60px', background: 'var(--ink)', opacity: 0.15,
        }} />
      )}
    </div>
  );
}
